// src/contexts/LangContext.js
import React, { createContext, useState, useContext } from "react";

const LangContext = createContext();

export const LangProvider = ({ children, initialLang = "nl" }) => {
  const [lang, setLang] = useState(initialLang);

  const toggleLang = () => {
    setLang(prev => (prev === "nl" ? "en" : "nl"));
  };

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
};

// Custom hook voor makkelijk gebruik in componenten
export const useLang = () => {
  return useContext(LangContext);
};